<template>
  <div
    :style="`width: ${width}`"
    class="overflow-hidden bg-white rounded-md shadow-sm"
  >
    <button
      class="flex items-center w-full px-2 py-2.5 relative"
      @click="handleCardClick"
    >
      <img
        :src="icon"
        class="object-contain w-6 h-6 flex-shrink-0 mr-2"
        alt=""
      />

      <span class="truncate pr-7">{{ text }}</span>

      <button
        class="absolute right-2 focus:outline-none focus:ring-2 focus:ring-blue-300 rounded-full"
        @click="handleDownloadClick"
        aria-label="Download"
      >
        <div class="w-5 h-5 object-contain" v-html="DOWNLOAD_ICON" />
      </button>
    </button>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { ResourceData } from "@/types/resource_types";
import { DOWNLOAD_ICON } from "@/assets/svg/shared/svg-constants";

export default defineComponent({
  name: "ResourceCard",
  props: {
    icon: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    downloadIcon: {
      type: String,
      default: "",
    },
    width: {
      type: String,
      default: "197px",
    },
    resourceType: {
      type: String,
      default: "",
    },
  },
  setup(props, { emit }) {
    const handleCardClick = (): void => {
      const resourceData: ResourceData = {
        type: props.resourceType,
        text: props.text,
      };
      emit("card-click", resourceData);
    };

    const handleDownloadClick = (event: Event): void => {
      event.stopPropagation();

      const resourceData: ResourceData = {
        type: props.resourceType,
        text: props.text,
      };
      emit("download-click", resourceData);
    };

    return {
      handleCardClick,
      handleDownloadClick,
      DOWNLOAD_ICON,
    };
  },
});
</script>
